import React, { Component } from 'react';
import { Routes, Route } from "react-router-dom";
import Home from './screens/Home';
import Nots from './screens/nots/Nots';
import Validator from './screens/validator/Validator';
import Rarity from './screens/Rarity/Rarity';
import Comic from './screens/Comics/Comic';
import Family from './screens/Family/Family';

export default class App extends Component {
  render() {
    return <Routes>
      <Route path="/family" element={<Family/>} />
      <Route path="/comic" element={<Comic/>} />
      <Route path="/" element={<Rarity/>} />
      {/* <Route path="/about" element={<Rarity />} />
      <Route path="/validator" element={<Rarity />} />
      <Route path="/rarity" element={<Rarity />} /> */}
    </Routes>;
  }
}
